export default "__VITE_ASSET__7a808f8b__"